import { start } from "@popperjs/core";

const block = $(".block-steps");
const container = $(".steps-navigation-container").first();
const parentContainer = $(".steps-root-container").first();
const menu = $("ul.steps-navigation").first();
const contentItems = $("ul.steps-content > li");
const menuItems = menu.find("li");
const navbar = $(".navbar").first();
let navbarHeight = navbar.outerHeight();
let menuWidth = menu.outerWidth();
const menuHeight = menu.outerHeight();

const ifAdminBar = () => {
  return $("body").hasClass("admin-bar");
};

container.height(container.outerHeight());

if (ifAdminBar()) {
  navbarHeight = navbarHeight + 32;
}

menu.css({ width: menuWidth });
//menu.css({ height: navbarHeight });

const handleMenuPosition = () => {
  const windowTop = $(window).scrollTop();
  const containerTop = container.offset().top;
  const endPoint =
    parentContainer.position().top +
    parentContainer.outerHeight(true) -
    (menuHeight + navbarHeight);
  let startingPoint = containerTop - navbarHeight;

  

  if (windowTop > startingPoint && windowTop < endPoint) {
    menu.addClass("sticky");
    menu.css({ top: navbarHeight });
    menu.css({ opacity: 1 });
  } else if (windowTop > endPoint) {
    menu.css({ opacity: 0 });
  } else {
    menu.removeClass("sticky");
    menu.css({ top: 0 });
    menu.css({ opacity: 1 });
  }
};

const handleMenuItems = () => {
  const windowTop = $(window).scrollTop();
  const containerTop = container.offset().top;
  let startingPoint = containerTop - navbarHeight;

  if (windowTop < startingPoint) {
    menuItems.eq(0).addClass("active");
  } else if (windowTop > startingPoint) {
    contentItems.each((i, e) => {
      const self = $(e);
      const start = self.offset().top - (navbarHeight + navbarHeight / 3);
      const end =
        self.offset().top +
        self.outerHeight() -
        (navbarHeight + navbarHeight / 3);
      if (windowTop > start && windowTop < end) {
        menuItems.eq(self.index()).addClass("active");
      } else {
        menuItems.eq(self.index()).removeClass("active");
      }
    });
  }
};

const handleScroll = () => {
  handleMenuPosition();
  handleMenuItems();
};

const Steps = () => {
  if (block.length) {
    menuItems.removeClass("active");
    menuItems.eq(0).addClass("active");

    $(document).on("scroll", handleScroll);
    menuItems.find("button").on("click", (e) => {
      const self = $(e.delegateTarget);
      const index = self.parent().index();
      $("html, body")
        .stop()
        .animate(
          { scrollTop: contentItems.eq(index).offset().top - navbarHeight },
          128
        );
    });
  }
};

export default Steps;
